import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Flex,
  HStack,
  IconButton,
  Image,
  Text,
  VStack,
  useDisclosure,
} from "@chakra-ui/react";
import { useMemo } from "react";
import { Link, Outlet } from "react-router-dom";
import useMe from "../../hooks/useMe";
import { colors } from "../../styles";
import MyIcon from "../Icon/MyIcon";
import LeftBar from "./LeftBar";
import Header from "./Header";
import Suspended from "../../routes/Auth/Suspended";

export default function Layout() {

  //////////////////////////////////////////////////////////////

  const { meData } = useMe();

  const userStatus = useMemo(() => meData?.user.status ?? "", [meData]);
  const username = useMemo(() => meData?.user.name ?? undefined, [meData]);

  //////////////////////////////////////////////////////////////

  const { isOpen, onOpen, onClose } = useDisclosure();

  //////////////////////////////////////////////////////////////

  return (
    <>
      {userStatus === "SUSPENDED" ? 
          <Suspended />
            :
          <Flex
            width={"100%"}
            height="100vh"
            direction={{ base: "column", lg: "row" }}
            gap={0}
            align="stretch"
            overflow="hidden"
          >

            {/* LeftBar ~ */}

              <Box display={{ base: "none", lg: "block" }} flexShrink={0}>
                <LeftBar username={username} />
              </Box>
              
            {/* ~ LeftBar */}

            {/* ~ Mobile Header */}

            <Header />

            {/* Main Content ~ */}

              <Box
                as="main"
                flex="1"
                minWidth={0}
                minHeight={0}
                overflowY="auto"
                overflowX="auto"
                display="flex"
                flexDirection="column"
              >
                <Outlet />
              </Box>
              
            {/* ~ Main Content */}

          </Flex>
      }
    </>
  );
}
